import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TextArea } from "../components/common/TextArea";
import { TextBox } from "../components/common/TextBox";
import PopupContent from "../components/popupContent";

import PopupOperationsBar from "./PopupOperationsBar";
import iconBaze from "../images/buttons/baze.png";
import { addNotification } from "../redux/actions";
import { apiGetAllProducts } from "../services/ProductsService";
import { SelectBox } from "../components/common/SelectBox";
import { apiCreateOrUpdateBasis, apiGetAllBasesByProduct, apiGetBasesDetail } from "../services/BasesService";
import { NumericBox } from "../components/common/NumericBox";
import ComboBoxData from "../components/common/ComboBoxData";
import { apiGetSampleCardsForProduct } from "../services/SampleCardsService";
import { apiGetAllColorsForSampleCard } from "../services/ColorsService";
import DataGrid from "../components/common/DataGrid";
import { apiGetAllPigments } from "../services/PigmentsService";
import Spinner from "../components/common/Spinner";
// styles
require("./PopupGeneralStyles.css");
require('./ReceiptPopupPigments.css');


interface Props {
    idReceipt?: number;
    idPigment?: any;
    handleCancel: any;
    handleConfirmation: any;
    refreshData: any;
    amount: any;
    productInLitres: boolean;
    allPigments: any[];
    customAmount:number;
}

const ReceiptPopup = (props: Props) => {

    const [loading, setLoading] = useState(true);
    const [saveError, setSaveError] = useState(false);

    let localStorageBaseAmountItemMl = sessionStorage.getItem('receiptBaseAmountInMl');
    let localStorageBaseAmountItemG = sessionStorage.getItem('receiptBaseAmountInG');


    let storedBaseAmount: number =
        props.productInLitres ?
            !localStorageBaseAmountItemMl ? 1000 : parseInt(localStorageBaseAmountItemMl) :
            !localStorageBaseAmountItemG ? 1000 : parseInt(localStorageBaseAmountItemG);

    const [formData, setFormData] = useState({ 'baseAmount': props.customAmount, 'amount': props.amount, 'amountInMililitres': 0 });
    const [selectedPigmentId, setSelectedPigmentId] = useState(props.idPigment);

    useEffect(() => {
        ensureAllDataForComponents();
    }, []);

    const ensureAllDataForComponents = async () => {
        let allPigments = await apiGetAllPigments();
        setLoading(false);

        if (!selectedPigmentId && allPigments.data.length > 0) {
            setSelectedPigmentId(allPigments.data[0].id);
        }
    }

    const onAddingClick = () => {

        let selectedPigment = props.allPigments.filter((a: any) => a.id == selectedPigmentId);
        let amountInMililitres = Math.round(formData.amount / selectedPigment[0]['density'] * 10000) / 10000;

        if (props.productInLitres) {
            sessionStorage.setItem('receiptBaseAmountInMl', formData.baseAmount.toString());
        }
        else {
            sessionStorage.setItem('receiptBaseAmountInG', formData.baseAmount.toString());
        }

        props.handleConfirmation(selectedPigmentId,
            selectedPigment[0]['name'],
            selectedPigment[0]['density'],
            formData.amount ,
            amountInMililitres);
    };

    const onEditingClick = () => {

        let selectedPigment = props.allPigments.filter((a: any) => a.id == selectedPigmentId);
        let amountInMililitres = Math.round(formData.amount  / selectedPigment[0]['density'] * 10000) / 10000;

        if (props.productInLitres) {
            sessionStorage.setItem('receiptBaseAmountInMl', formData.baseAmount.toString());
        }
        else {
            sessionStorage.setItem('receiptBaseAmountInG', formData.baseAmount.toString());
        }

        props.handleConfirmation(selectedPigmentId,
            selectedPigment[0]['name'],
            selectedPigment[0]['density'],
            formData.amount ,
            amountInMililitres);
    };

    const handlePigmentChange = (id) => {
        setSelectedPigmentId(id);
    }

    const onCancelClick = () => {
        props.handleCancel();
    };

    let amountDescription = props.productInLitres ? `na ${formData.baseAmount} ml` : `na ${formData.baseAmount} g`;
    let amountInMililitres = 0;
    let selectedPigment = props.allPigments.filter((a: any) => a.id == selectedPigmentId);

    if (selectedPigment && selectedPigment.length > 0) {
        amountInMililitres = Math.round(formData.amount / selectedPigment[0]['density'] * 10000) / 10000;
    }
    return (
        <PopupContent
            headerIcon={iconBaze}
            additionalClassNames={'ReceiptPigmentPopup'}
            header={props.idReceipt ? "Úprava pigmentu" : "Přidání pigmentu"}
        >
            <>
                {(loading) && <Spinner loadingText="Loading" />}

                <ComboBoxData
                    id="pigments"
                    label="Pigment"
                    dataTextField="name"
                    dataValueField="id"
                    defaultValue={selectedPigmentId}
                    handleChange={handlePigmentChange}
                    rows={props.allPigments}
                    customLeftCols='col-sm-4'
                    customRightCols='col-sm-8'
                />

                <div className="row">
                    <div className="col-sm-4 col-form-label zvlabel">
                        <label htmlFor="baseAmount">Množství báze v {props.productInLitres ? 'ml' : 'g'}:</label>
                    </div>
                    <div className="col-sm-8 " style={{ paddingLeft: '20px' }}>
                        
                        {/*<input type="number" className="form-control" id="baseAmount" value={formData.baseAmount}
                            onChange={(event) => {
                                let newState = { ...formData };
                                debugger
                                newState.baseAmount = event.target.valueAsNumber;
                                setFormData(newState);
                            }}
                        />*/}
                        {formData.baseAmount}
                    </div>
                </div>


                <NumericBox
                    decimalPlaces={4}
                    dataField="amount"
                    defaultValue={formData.amount}
                    formData={formData}
                    setStateMethod={setFormData}
                    id="amountInGrams"
                    label={`Množství v g (${amountDescription})`}
                    customLeftCols='col-sm-4'
                    customRightCols='col-sm-8'
                />
                        *

                <div className="row">
                    <label className="col-sm-4 col-form-label zvlabel">
                        {`Množství v ml (${amountDescription})`}
                    </label>

                    <div className="col-sm-8" style={{ padding: '7px', paddingLeft: '20px' }}>
                        {amountInMililitres}
                    </div>
                </div>

                <PopupOperationsBar
                    handleAdding={onAddingClick}
                    handleCancellation={onCancelClick}
                    handleEditing={onEditingClick}
                    id={props.idReceipt}
                />
            </>
        </PopupContent>
    );
};

export default ReceiptPopup;

